import './App.less';
import { Provider as StoreProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import themes from '@root/constants/theme';
import store, { persistor } from './store/configureStore';
import Routes from './router';
import '@root/services/hotjar'

function App() {
  return (
    
    <StoreProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={themes}>
          <Routes />
        </ThemeProvider>
      </PersistGate>
    </StoreProvider>
  );
}

export default App;
